import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth, formatApiErrorDetail } from "../context/AuthContext";
import { AuthShell } from "./Login";

const inputCls =
  "w-full bg-[#0D0D0D] border border-[#222] focus:border-[#E6DFD4] outline-none text-[#F5F5F5] px-4 py-3.5 text-sm placeholder:text-[#5a5a5a] transition-colors duration-300";

const GoogleMark = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
    <path fill="#EA4335" d="M12 10.2v3.9h5.5c-.24 1.4-1.6 4.1-5.5 4.1-3.3 0-6-2.7-6-6s2.7-6 6-6c1.9 0 3.1.8 3.8 1.5l2.6-2.5C16.7 2.9 14.6 2 12 2 6.9 2 2.8 6.1 2.8 11.2S6.9 20.4 12 20.4c5.9 0 9.8-4.1 9.8-9.9 0-.7-.1-1.2-.2-1.7H12z" />
  </svg>
);

export default function Register() {
  const { register, loginWithGoogle } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await register(name, email, password);
      toast.success("Account created");
      navigate("/account");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Create Account" subtitle="Save your delivery details and track every order.">
      <button
        data-testid="google-register-button"
        onClick={loginWithGoogle}
        className="w-full flex items-center justify-center gap-3 bg-[#F5F5F5] text-black py-3.5 text-xs tracking-[0.15em] uppercase font-bold hover:bg-white transition-colors duration-300"
      >
        <GoogleMark /> Continue with Google
      </button>

      <div className="flex items-center gap-4 my-6">
        <div className="h-px flex-1 bg-[#222]" />
        <span className="text-[10px] tracking-[0.3em] uppercase text-[#5a5a5a]">or</span>
        <div className="h-px flex-1 bg-[#222]" />
      </div>

      <form onSubmit={submit} className="space-y-4">
        <input data-testid="register-name-input" required placeholder="Full name" value={name} onChange={(e) => setName(e.target.value)} className={inputCls} />
        <input data-testid="register-email-input" type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} />
        <input data-testid="register-password-input" type="password" required minLength={6} placeholder="Password (min 6 chars)" value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} />
        {error && <p data-testid="register-error" className="text-sm text-red-400">{error}</p>}
        <button data-testid="register-submit-button" type="submit" disabled={loading} className="w-full bg-[#E6DFD4] text-black py-4 text-xs tracking-[0.2em] uppercase font-bold hover:bg-white transition-colors duration-300 disabled:opacity-50">
          {loading ? "Creating..." : "Create Account"}
        </button>
      </form>

      <p className="mt-6 text-sm text-[#A3A3A3]">
        Already have an account?{" "}
        <Link data-testid="go-login-link" to="/login" className="text-[#E6DFD4] font-bold border-b border-[#E6DFD4]">Log in</Link>
      </p>
    </AuthShell>
  );
}
